import { CODE_LANG_CONFIG, SUPPORTED_CODE_LANGS } from './code-lang.config';
import { SupportedCodeLang } from './code-lang.types';

function getCodeLangConfig(lang: SupportedCodeLang) {
  return CODE_LANG_CONFIG[lang];
}

function isSupportedCodeLang(lang: string): lang is SupportedCodeLang {
  return (SUPPORTED_CODE_LANGS as readonly string[]).includes(lang);
}

function isLang<T extends SupportedCodeLang>(
  lang: SupportedCodeLang,
  target: T
): lang is T {
  return lang === target;
}

export {
  getCodeLangConfig,
  isSupportedCodeLang,
  isLang,
};